/** Market page for an outcome outside the venue scope (#689): no book, no order ticket. */
import { Link } from 'react-router-dom';
import { venueLabel } from './scope';
import { useVenueScope } from './useVenueScope';
import Msg from '../i18n/Msg';
import { networkWord } from '../i18n/common';
import { useT } from '../i18n/useT';

export default function OutOfVenue({ outcome, outcomeVenue, envName }: { outcome: number; outcomeVenue?: string; envName: string }) {
  const scope = useVenueScope();
  const t = useT();
  const strong = (s: string) => <span className="font-medium text-fg">{s}</span>;
  return (
    <section className="flex flex-col items-center gap-3 py-16 text-center" data-testid="outcome-out-of-venue">
      <h1 className="text-lg font-semibold">{t('venue.out.title', { outcome: String(outcome) })}</h1>
      <p className="max-w-md text-sm text-muted">
        {outcomeVenue ? (
          <Msg
            k="venue.out.body_other"
            args={{ venue: strong(venueLabel(scope.venue)), network: networkWord(envName), other: strong(outcomeVenue) }}
          />
        ) : (
          <Msg k="venue.out.body" args={{ venue: strong(venueLabel(scope.venue)), network: networkWord(envName) }} />
        )}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
        <Link to="/" className="text-accent hover:underline">
          {t('common.back_to_markets')}
        </Link>
        {!scope.isLocked && (
          <button type="button" className="text-accent hover:underline" onClick={() => scope.setVenue(null)}>
            {t('venue.out.show_all')}
          </button>
        )}
      </div>
    </section>
  );
}
